import React from 'react';
// import dashboardStyles from '../../styles/dashboardStyles';
// import { colors } from '../../theme/colors';

import { Header } from '../../components/Header/Headers';
// import LineCharts from './Components/LineCharts';
import DashboardCards from './Components/DashboardCards';
// import BarChartsWithFilters from './Components/BarChartsWithFilters';
// import ChartSelector from './Components/ChartSelector';
import { ComparisonCardsChart } from './Components/ComparisonCardsChart';


const DashboardOverviewSection: React.FC = () => {
  return (
    <>
      <Header title="Dashboard Overview" breadcrumb="Admin Console / Dashboard" />
      <DashboardCards />
      <ComparisonCardsChart />
      {/* <LineCharts />
      <BarChartsWithFilters />
      <ChartSelector /> */}
    </>
  );
};

export default DashboardOverviewSection;